import { RecordType } from 'app/constants/GlobalTypes'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import useTranslation from 'app/lib/hooks/useTranslation'
import MachineSearch from 'app/pages/Checkout/Container/MachineSearch'
import { useParams } from 'react-router-dom'

type MachineSearchProps = React.ComponentProps<typeof MachineSearch>

export default function useMachineSearch() {
  const { checkout_id } = useParams<{ checkout_id: string }>()
  const { tCore } = useTranslation({
    scope: 'drawer',
    recordType: RecordType.checkout
  })

  const { drawerfy } = useFeedbacker()

  const open = (props: Partial<MachineSearchProps> = {}) => {
    const content = <MachineSearch rentalId={checkout_id} {...props} />

    drawerfy.open({
      content,
      title: tCore({
        id: 'machine_search'
      }),
      width: 600,
      drawerType: 'page',
      push: false
    })
  }

  return { open }
}
